
import Vue from 'vue';

export default Vue.extend({
	name: 'BaseBreadcrumbs',
	props: {
		items: { type: Array, default: () => [] },
	},
	methods: {
		onBreadcrumbClick({ to, disabled }) {
			if (to && !disabled) {
				this.routerPush(this.$route, this.$router, to);
			}
		},
	},
});
